import React, { useState } from "react";
import { Button, Card, Carousel, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import './PostsStyle.css'
import cards from '../assets/data/allPostblogCardInfo' 


const Blogs = () => {
	const [index, setIndex] = useState(0);

	const handleSelect = (selectedIndex) => {
		setIndex(selectedIndex);
	};

	return (
		<Carousel
			activeIndex={index}
			onSelect={handleSelect}
			controls={true}
			indicators={false}
		>
			{cards.map((blog, i) => (
				<Carousel.Item key={i}>
					<Row className="d-flex align-items-stretch">
						{blog.map((item, i) => (
							<Col xs={12} lg={4} className="mt-4 mt-lg-5" key={i}>
								<Card className="h-100">
									<div className="position-relative">
										<img src={item.img} className="card-img-top" alt="..." />
									</div>
									<Card.Body dir="rtl" className="d-flex flex-column">
										
											<p className="card-text mb-2">{item.category}</p>
										
											<Link to={`/blog/${item.id}`} style={{ textDecoration: 'none' }}>
												<h5 className="card-title mb-2">{item.title}</h5>
											</Link>
										<p className="card-text">{item.text}</p>
										<div className="d-flex justify-content-between mb-2 mt-auto">
											<div className="d-flex align-items-center">
												<div className="me-2">
													<img
														src={item.authorImg}
														alt=""
														// className=
														width="40"
													/>
												</div>
											</div>

											<Link to={`/blog/${item.id}`} style={{ textDecoration: 'none' }}>
												<Button 
													variant="outline-primary"
													className="ezy__blog15-card-btn d-flex align-items-center"
												>
												میخونم
												</Button>
											</Link>


										</div>
									</Card.Body>
								</Card>
							</Col>
						))}
					</Row>
				</Carousel.Item>
			))}
		</Carousel>
	);
};

const allPosts = () => {
	return (
		<section className="ezy__blog15 light">
			<Container>
				<Row className="justify-content-center">
					<Col xs={12} dir="rtl">
						<h1 className="ezy__blog15-heading"> پست‌ها</h1>
					</Col>
					<Blogs />
				</Row>
			</Container>
		</section>
	);
};

export default allPosts;